window.initialiseLighteezCuts = (root, config) => {
if(root.updateConfig){root.updateConfig(config);return;}
  /* ── Config from data attributes ── */
  var pricePerMetre = config.price;
  var variantId = config.variant;
  var cutIncrement  = config.increment;
  var maxLength     = config.maxLength;
  var minCutLength  = cutIncrement / 1000;
  var maxWholeMetres = Math.floor(maxLength);
  var MAX_ROWS      = 5;

  /* ── DOM refs (qty/cut elements may be null when sold-out at render) ── */
  var toggleBtns       = root.querySelectorAll('[data-cts-toggle]');
  var metrePanel       = root.querySelector('[data-cts-panel="metre"]');
  var cutPanel         = root.querySelector('[data-cts-panel="cut"]');
  var qtyInput         = root.querySelector('[data-cts-qty]');
  var qtyMinus         = root.querySelector('[data-cts-qty-minus]');
  var qtyPlus          = root.querySelector('[data-cts-qty-plus]');
  var metreTotalEl     = root.querySelector('[data-cts-metre-total]');
  var addMetreBtn      = root.querySelector('[data-cts-add-metre]');
  var cutsContainer    = root.querySelector('[data-cts-cuts]');
  var addRowBtn        = root.querySelector('[data-cts-add-row]');
  var errorEl          = root.querySelector('[data-cts-error]');
  var summaryEl        = root.querySelector('[data-cts-summary]');
  var addCutBtn        = root.querySelector('[data-cts-add-cut]');

  /* ── Helpers ── */
  function vatMode() {
    try { return localStorage.getItem('vatPreference') || 'inc'; } catch(e) { return 'inc'; }
  }

  function vatLabel() {
    return vatMode() === 'ex' ? 'EX VAT' : 'INC VAT';
  }

  function fmtMoney(pence) {
    var exVat = vatMode() === 'ex';
    var display = exVat ? Math.round(pence / 1.2) : pence;
    return '\u00A3' + (display / 100).toFixed(2);
  }

  function snapDown(metres) {
    var mm = Math.round(metres * 1000);
    var snapped = Math.floor(mm / cutIncrement) * cutIncrement;
    return snapped / 1000;
  }

  function updateVatBadges() {
    root.querySelectorAll('[data-vat-badge]').forEach(function(el) {
      el.textContent = vatLabel();
    });
  }

  /* ══════════════════════════════════════════════
     TOGGLE (tabs)
     ══════════════════════════════════════════════ */

  toggleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = btn.dataset.ctsToggle;

      toggleBtns.forEach(function(b) {
        var isActive = b.dataset.ctsToggle === target;
        b.classList.toggle('cts__tab--active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false'); b.tabIndex=isActive?0:-1;
      });

      if (target === 'metre') {
        metrePanel.hidden = false;
        cutPanel.hidden = true;
      } else {
        metrePanel.hidden = true;
        cutPanel.hidden = false;
      }
    });
  });

  /* ══════════════════════════════════════════════
     PANEL A — Buy by the metre
     ══════════════════════════════════════════════ */

  function getQty() {
    if (!qtyInput) return 1;
    var v = parseInt(qtyInput.value, 10);
    if (isNaN(v) || v < 1) return 1;
    return v;
  }

  function updateMetreTotal() {
    if (!metreTotalEl || !qtyInput) return;
    var qty = getQty();
    var valid = Number.isInteger(Number(qtyInput.value)) && Number(qtyInput.value)>=1 && qty<=maxWholeMetres;
    addMetreBtn.disabled = !valid || !config.orderable;
    root.querySelector("[data-cts-metre-error]").textContent = valid ? "One continuous length, with one fitted lead." : "Choose a whole-metre length from 1 to " + maxWholeMetres + "m per connection.";
    var total = pricePerMetre * qty;
    metreTotalEl.textContent = fmtMoney(total);
    updateVatBadges();
    setButtonLabels();
  }

  if (qtyMinus) qtyMinus.addEventListener('click', function() {
    var v = getQty();
    if (v > 1) { qtyInput.value = v - 1; updateMetreTotal(); }
  });

  if (qtyPlus) qtyPlus.addEventListener('click', function() {
    var v = getQty();
    qtyInput.value = Math.min(v + 1,maxWholeMetres);
    updateMetreTotal();
  });

  if (qtyInput) qtyInput.addEventListener('input', function() {
    var v = parseInt(qtyInput.value, 10);
    if (!isNaN(v) && v < 1) qtyInput.value = 1;
    updateMetreTotal();
  });

  /* ══════════════════════════════════════════════
     PANEL B — Cut to my exact size
     ══════════════════════════════════════════════ */

  var rowCount = 0;

  function addCutRow() {
    if (!cutsContainer) return;
    if (rowCount >= MAX_ROWS) return;
    rowCount++;
    var idx = rowCount;

    var row = document.createElement('div');
    row.className = 'cts__cut-row';
    row.dataset.ctsRow = idx;

    var body = document.createElement('div');
    body.className = 'cts__cut-row-body';

    var label = document.createElement('label');
    label.className = 'cts__cut-label';
    label.textContent = 'Length ' + idx;
    label.setAttribute('for', 'cts-length-' + idx);

    var wrap = document.createElement('div');
    wrap.className = 'cts__cut-input-wrap';

    var input = document.createElement('input');
    input.type = 'text';
    input.inputMode = 'decimal';
    input.className = 'cts__cut-input';
    input.id = 'cts-length-' + idx;
    input.placeholder = '0.00';
    input.dataset.ctsLength = '';

    var unit = document.createElement('span');
    unit.className = 'cts__cut-unit';
    unit.textContent = 'm';

    wrap.appendChild(input);
    wrap.appendChild(unit);

    var snap = document.createElement('p');
    snap.className = 'cts__cut-snap';
    snap.dataset.ctsSnap = '';

    body.appendChild(label);
    body.appendChild(wrap);
    body.appendChild(snap);
    row.appendChild(body);

    /* Remove button (hidden on first row) */
    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'cts__cut-remove';
    removeBtn.setAttribute('aria-label', 'Remove length ' + idx);
    removeBtn.textContent = '\u00D7';
    if (rowCount === 1) removeBtn.hidden = true;
    removeBtn.addEventListener('click', function() {
      row.remove();
      rowCount--;
      renumberRows();
      recalcCuts();
      updateAddRowBtn();
    });
    row.appendChild(removeBtn);

    /* Input filtering — positive numbers and decimal point only */
    input.addEventListener('input', function() {
      var v = input.value;
      /* Strip anything that isn't a digit or decimal point */
      v = v.replace(/[^0-9.]/g, '');
      /* Only allow one decimal point */
      var parts = v.split('.');
      if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');
      input.value = v;
      recalcCuts();
    });

    cutsContainer.appendChild(row);
    updateAddRowBtn();
    if (document.activeElement === addRowBtn) input.focus();
  }

  function renumberRows() {
    var rows = cutsContainer.querySelectorAll('[data-cts-row]');
    rows.forEach(function(row, i) {
      var num = i + 1;
      row.dataset.ctsRow = num;
      var label = row.querySelector('.cts__cut-label');
      var input = row.querySelector('.cts__cut-input');
      var removeBtn = row.querySelector('.cts__cut-remove');
      if (label) label.textContent = 'Length ' + num;
      if (input) input.id = 'cts-length-' + num;
      if (label) label.setAttribute('for', 'cts-length-' + num);
      if (removeBtn) {
        removeBtn.setAttribute('aria-label', 'Remove length ' + num);
        removeBtn.hidden = (num === 1 && rows.length === 1);
      }
    });
    /* Show remove buttons on all rows when there are 2+ rows */
    if (rows.length > 1) {
      rows.forEach(function(row) {
        var btn = row.querySelector('.cts__cut-remove');
        if (btn) btn.hidden = false;
      });
    }
  }

  function updateAddRowBtn() {
    if (!addRowBtn) return;
    addRowBtn.disabled = (rowCount >= MAX_ROWS);
  }

  function recalcCuts() {
    if (!cutsContainer || !addCutBtn || !summaryEl) return;
    var inputs = cutsContainer.querySelectorAll('[data-cts-length]');
    var cuts = [];
    var totalSnapped = 0;
    var hasValue = false;
    var hasError = false;

    inputs.forEach(function(input, i) {
      var raw = parseFloat(input.value);
      var snapEl = input.closest('.cts__cut-row-body').querySelector('[data-cts-snap]');

      if (isNaN(raw) || raw <= 0 || input.value.trim() === '') {
        if (snapEl) snapEl.textContent = '';
        if(input.value.trim() !== '') hasError=true;
        cuts.push({ raw: 0, snapped: 0, valid: false });
        return;
      }

      hasValue = true;
      var snapped = snapDown(raw);

      if (snapped < minCutLength) {
        if (snapEl) snapEl.textContent = 'Minimum length is ' + minCutLength + 'm';
        cuts.push({ raw: raw, snapped: 0, valid: false });
        hasError = true;
        return;
      }

      if (snapped > maxLength) {
        if (snapEl) snapEl.textContent = 'Maximum single length is ' + maxLength + 'm';
        cuts.push({ raw: raw, snapped: 0, valid: false });
        hasError = true;
        return;
      }

      if (snapEl) {
        if (snapped !== raw) {
          snapEl.textContent = 'We\u2019ll cut to ' + snapped.toFixed(2) + 'm (nearest cut point)';
        } else {
          snapEl.textContent = 'Cut to ' + snapped.toFixed(2) + 'm';
        }
      }

      totalSnapped += snapped;
      cuts.push({ raw: raw, snapped: snapped, valid: true });
    });

    /* Round to avoid floating point drift */
    totalSnapped = Math.round(totalSnapped * 1000) / 1000;

    /* Summary */
    var validCuts = cuts.filter(function(c) { return c.valid; });

    if (validCuts.length > 0 && !hasError) {
      var html = '';
      var cutNum = 0;
      cuts.forEach(function(c) {
        if (!c.valid) return;
        cutNum++;
        html += '<div class="cts__summary-line"><span>Cut ' + cutNum + '</span><span>' + c.snapped.toFixed(2) + 'm</span></div>';
      });

      html += '<hr class="cts__summary-divider">';
      html += '<div class="cts__summary-line cts__summary-total"><span>Total length</span><span>' + totalSnapped.toFixed(2) + 'm</span></div>';

      var totalPence = Math.round(pricePerMetre * totalSnapped);
      html += '<div class="cts__summary-price"><span>Total price: ' + fmtMoney(totalPence) + '</span><span class="cts__vat-badge" data-vat-badge>' + vatLabel() + '</span></div>';

      summaryEl.innerHTML = html;
      summaryEl.hidden = false;

      addCutBtn.disabled = false;
      addCutBtn.setAttribute('aria-disabled', 'false');
    } else {
      summaryEl.hidden = true;
      addCutBtn.disabled = true;
      addCutBtn.setAttribute('aria-disabled', 'true');
    }

    if (!config.orderable) addCutBtn.disabled = true;
    setButtonLabels();
    /* Also disable if no values entered */
    if (!hasValue) {
      addCutBtn.disabled = true;
      addCutBtn.setAttribute('aria-disabled', 'true');
    }
  }

  /* Init first cut row (skipped when sold-out — cuts container isn't rendered) */
  addCutRow();

  if (addRowBtn) addRowBtn.addEventListener('click', function() {
    if (rowCount < MAX_ROWS) addCutRow();
  });

  /* ══════════════════════════════════════════════
     ADD TO CART
     ══════════════════════════════════════════════ */


  function setButtonLabels() {
    [addMetreBtn,addCutBtn].forEach(btn=>{btn.textContent=config.orderable?'Add to Basket':'Currently unavailable';btn.setAttribute('aria-disabled',String(btn.disabled));});
  }
  root.querySelectorAll('[role=tab]').forEach((tab,i)=>tab.addEventListener('keydown',e=>{
    if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();const tabs=[...toggleBtns],target=e.key==='Home'?0:e.key==='End'?1:1-i;tabs[target].click();tabs[target].focus();}
  }));
  root.updateConfig = next => {
    config=next;pricePerMetre=next.price;variantId=next.variant;cutIncrement=next.increment;maxLength=next.maxLength;minCutLength=cutIncrement/1000;maxWholeMetres=Math.floor(maxLength);
    qtyInput.max=String(maxWholeMetres);
    root.querySelector('[data-cts-increment]').textContent='Enter each length in metres. Cut points are '+cutIncrement+'mm apart; we show the nearest cut point below your measurement. Maximum '+maxLength+'m per separate length.';
    updateMetreTotal();recalcCuts();
  };
  root.getCuts = () => {
    if(!metrePanel.hidden){const qty=Number(qtyInput.value);return Number.isInteger(qty)&&qty>=1&&qty<=maxWholeMetres?[qty]:[];}
    const entries=[...cutsContainer.querySelectorAll('[data-cts-length]')].map(el=>el.value.trim()).filter(Boolean);
    const lengths=entries.map(value=>snapDown(Number(value)));
    return lengths.every(n=>Number.isFinite(n)&&n>=minCutLength&&n<=maxLength)?lengths:[];
  };
  async function order(mode,btn) {
    if(!config.orderable||btn.disabled)return;
    let cuts=root.getCuts();if(!cuts.length)return;
    let total=cuts.reduce((a,b)=>a+b,0);
    const props={_order_type:mode,_price_per_metre:String(pricePerMetre),_cut_increment_mm:String(cutIncrement),_length_m:total.toFixed(2),'Order type':mode==='cut_to_size'?'Cut to size':'By the metre','Included':'Fitted 2m Dupont lead on every separate length'};
    if(config.parentSku)props._parent_sku=config.parentSku;
    if(mode==='cut_to_size'){props._cuts_json=JSON.stringify(cuts.map(n=>({length_m:n.toFixed(2)})));cuts.forEach((n,i)=>{props['Cut '+(i+1)]=n.toFixed(2)+'m';});props['Total length']=total.toFixed(2)+'m';}else props.Length=cuts[0]+'m';
    btn.disabled=true;btn.textContent='Adding…';
    try { await config.addToCart([{id:variantId,quantity:1,properties:props}]);root.querySelector('[data-cts-status]').textContent='Added to your basket.'; }
    catch(e){root.querySelector('[data-cts-status]').textContent=e.message;}
    finally{root.updateConfig(config);}
  }
  addMetreBtn.addEventListener('click',()=>order('by_the_metre',addMetreBtn));addCutBtn.addEventListener('click',()=>order('cut_to_size',addCutBtn));
  window.addEventListener('vatPreferenceChanged',()=>{updateMetreTotal();recalcCuts();});
  root.updateConfig(config);
};
